
<ng-container *ngIf="manager.state$ | async as state">

    <ng-container *ngIf="state.status === 'loading'">
        <div class="loading">
            <span class="spinner"></span>
        </div>
    </ng-container>

    <ng-container *ngIf="state.status === 'error'">
        <feedback-state ui-kit
            [title]="state.errorMessage || 'Произошла ошибка'"
            [text]="state.errorText || 'Попробуйте обновить страницу или повторите позже.'"
            [button]="null"
            [secondButton]="null"
            caption=""
        ></feedback-state>
    </ng-container>

    <ng-container *ngIf="state.status === 'ready'">
        <ng-container *ngIf="manager.activeSession$ | async as session; else sessionList">
            <chat-session-view
                class="chat-manager__inline-session"
                [session]="session"
                [template]="manager.template"
                [restoreScrollTop]="restoreScrollTop"
                (scrollPositionChange)="scrollPositionChange.emit($event)"
            ></chat-session-view>
        </ng-container>

        <ng-template #sessionList>
            <scroll-bar ui-kit paddingX="3xl" class="content">
                <div class="search" *ngIf="viewConfig.showSearch">
                    <ui-input ui-kit
                        placeholder="Поиск"
                        size="small"
                        (input)="onSearchInput($event)"
                    ></ui-input>
                </div>

                <ng-container *ngIf="viewConfig.showSearch && (searchQuery$ | async) as query; else defaultList">

                    <ng-container *ngIf="query">
                        <ng-container *ngIf="{ sessions: searchSessions$ | async, messages: searchMessages$ | async } as results">

                            <ng-container *ngIf="results.sessions?.length || results.messages?.length; else emptySearch">
                                <chat-search-sessions
                                    *ngIf="results.sessions?.length"
                                    [sessions]="results.sessions!"
                                    (sessionSelected)="manager.openSession($event)"
                                ></chat-search-sessions>
                                <chat-search-messages
                                    *ngIf="results.messages?.length"
                                    [messages]="results.messages!"
                                    (messageSelected)="manager.openSessionAtMessage($event)"
                                ></chat-search-messages>
                            </ng-container>

                            <ng-template #emptySearch>
                                <feedback-state ui-kit
                                    title="Ничего не найдено"
                                    text="Попробуйте изменить запрос."
                                    [button]="null"
                                    [secondButton]="null"
                                    caption=""
                                ></feedback-state>
                            </ng-template>

                        </ng-container>
                    </ng-container>

                </ng-container>

                <ng-template #defaultList>
                    <ng-container *ngIf="{
                        sessions: (manager.sessions$ | async) || [],
                        hasMore: (manager.sessionsHasMore$ | async) || { before: false, after: false },
                        loading: (manager.sessionsIsLoadingMore$ | async) || { before: false, after: false }
                    } as list">
                        <chat-session-list
                            *ngIf="list.sessions.length || list.hasMore.after; else emptyList"
                            [sessions]="list.sessions"
                            [type]="viewConfig.chatSession.type"
                            [showAvatar]="viewConfig.chatSession.showAvatar"
                            [menuItems]="viewConfig.chatSession.menuItems || null"
                            [createLabel]="viewConfig.chatSession.createLabel"
                            [hasMoreBefore]="list.hasMore.before"
                            [hasMoreAfter]="list.hasMore.after"
                            [isLoadingBefore]="list.loading.before"
                            [isLoadingAfter]="list.loading.after"
                            (createClicked)="createSession()"
                            (sessionDeleted)="deleteSession($event)"
                            (sessionSelected)="manager.openSession($event)"
                            (loadMoreBefore)="manager.loadMoreSessions('before')"
                            (loadMoreAfter)="manager.loadMoreSessions('after')"
                        ></chat-session-list>
                    </ng-container>
                </ng-template>
            </scroll-bar>
            <div class="footer" *ngIf="viewConfig.showInputWithoutSession && !(searchQuery$ | async)">
                <chat-input
                    [allowFiles]="viewConfig.chatInput.allowFiles"
                    [allowVoice]="viewConfig.chatInput.allowVoice"
                    (messageSent)="startSessionWithMessage($event)"
                ></chat-input>
            </div>
        </ng-template>
    </ng-container>

</ng-container>

<ng-template #emptyList>
    <feedback-state ui-kit
        *ngIf="viewConfig.emptySessionListInfo"
        [button]="viewConfig.emptySessionListInfo.button"
        [secondButton]="viewConfig.emptySessionListInfo.secondButton"
        [caption]="viewConfig.emptySessionListInfo.caption"
        [illustrationName]="viewConfig.emptySessionListInfo.illustrationName"
        [title]="viewConfig.emptySessionListInfo.title"
        [text]="viewConfig.emptySessionListInfo.text"
    ></feedback-state>
</ng-template>
